import { cn } from '../../lib/utils';

interface FolderPathLabelProps {
    title: string;
    parentTitle?: string;
    className?: string;
}

export const FolderPathLabel = ({
    title,
    parentTitle,
    className,
}: FolderPathLabelProps) => (
    <span
        className={cn('min-w-0 truncate', className)}
        title={parentTitle ? `${parentTitle} › ${title}` : title}
    >
        {parentTitle && (
            <span className="font-medium text-subtle-foreground">
                {parentTitle} ›{' '}
            </span>
        )}
        {title}
    </span>
);
